import { render, staticRenderFns } from "./AboutUsComponent.vue?vue&type=template&id=30ac63f8&"
import script from "./AboutUsComponent.vue?vue&type=script&lang=js&"
export * from "./AboutUsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports